import React from 'react';

export interface SectionTitleProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ children, className = '', style = {} }) => {
    const titleStyles: React.CSSProperties = {
        fontSize: '20px',
        fontWeight: 600,
        color: 'var(--malachite-text-primary)',
        lineHeight: '1.3',
        margin: 0,
        ...style,
    };

    return (
        <h3 className={className} style={titleStyles}>
            {children}
        </h3>
    );
};

export default SectionTitle;
